export default __webpack_public_path__ + "static/media/ajustment.2f7138de.png";